import { publicPath} from "request"

interface IProps { 
    emptyText?:React.ReactNode
}

export const Empty: React.FC<IProps> = ({ emptyText}) => { 
    return (
      <div className="flex items-center flex-col justify-center h-3/5">
        <img
          src={`${publicPath}/icons/img_nodata.png`}
          className="w-[108px]"
          alt="empty"
        />
        {emptyText && <p className="mt-4 text-gray999">{emptyText}</p>}
      </div>
    );
}